import { MapPreviewImage } from "../map-preview";
import { FieldPair, Section } from "./section";

interface InsuredData {
  insured: string | null;
  contactFullName: string | null;
  contactFirstName: string | null;
  contactAddress1: string | null;
  contactAddress2: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
  address: string | null;
  buildingName: string | null;
  numberOfUnits: number | null;
  lat: number | null;
  lng: number | null;
  instructingParty: string | null;
  instructingEmail: string | null;
  invoiceTo: string | null;
}

export function SectionInsured({ data }: { data: InsuredData }): React.ReactElement {
  return (
    <Section id="insured" title="Insured & Contact">
      <div className="grid gap-4 md:grid-cols-2">
        <div className="grid grid-cols-2 gap-x-4 gap-y-3">
          <FieldPair label="Insured" value={data.insured} />
          <FieldPair label="Contact Full Name" value={data.contactFullName} />
          <FieldPair label="Contact First Name" value={data.contactFirstName} />
          <FieldPair label="Contact Phone" value={data.contactPhone} />
          <FieldPair label="Contact Address 1" value={data.contactAddress1} />
          <FieldPair label="Contact Email" value={data.contactEmail} />
          <FieldPair label="Contact Address 2" value={data.contactAddress2} />
        </div>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-x-4 gap-y-3">
            <FieldPair label="Address" value={data.address} />
            <FieldPair label="Building Name" value={data.buildingName} />
            <FieldPair label="Number of Residential Units" value={data.numberOfUnits?.toString()} />
          </div>
          {data.lat && data.lng && (
            <MapPreviewImage lat={data.lat} lng={data.lng} className="h-40" data-testid="map-preview" />
          )}
        </div>
        <div className="grid grid-cols-3 gap-x-4 gap-y-3 md:col-span-2 pt-2 border-t">
          <FieldPair label="Instructing Party" value={data.instructingParty} />
          <FieldPair label="Instructing Email" value={data.instructingEmail} />
          <FieldPair label="Invoice To" value={data.invoiceTo} />
        </div>
      </div>
    </Section>
  );
}
